import { useIsOwner } from '@aibees/shared/workspace';

export function useCanInvite() {
  const { isAdmin, isOwner } = useIsOwner();
  return isOwner || isAdmin;
}
